import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/_services/global.service';
import { MmitaAssetService } from 'src/app/_services/mmitaAsset.service';
import { ModalService } from 'src/app/_services/modal.service';
import { BaseComponent } from 'src/app/ui-library/component/base.component';
import { LibraryService } from './library.service';
import { ToastrService } from 'ngx-toastr';
import { NzModalService } from 'ng-zorro-antd/modal';
import { LibraryItemComponent } from './library-item/library-item.component';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.css']
})
export class LibraryComponent extends BaseComponent {
  data: Array<any> = [];
  constructor(
    public global: Global,
    private assetService: MmitaAssetService,
    private modalService: ModalService,
    private libraryService: LibraryService,
    private toastr: ToastrService,
    private nzModalService: NzModalService
  ) {
    super(global);
  }

  ngOnInit(): void {
    this.setColumnDefs();
  }


  setColumnDefs() {
    this.columnDefs = [
      { headerName: 'Order', field: 'order' },
      { headerName: 'ID', field: 'categoryId' },
      { headerName: 'Category Name', field: 'categoryName' },
      { headerName: 'Localization Key', field: 'localizationKey' },
      { headerName: 'Max Size', field: 'maxSize' },
      { headerName: 'Tab Type', field: 'tabType' },
      { headerName: 'Url', field: 'url' },
      {
        headerName: 'Action',
        pinned: 'right',
        minWidth: 120,
        cellRenderer: params => {
          return `  <i class="fas fa-fw fa-bars" id="moreDetail" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-edit text-primary" id="editDetail" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-trash grid-btn-icon text-danger" id="delete" style="margin-right:3px; cursor: pointer;"></i>`;
        },
        onCellClicked: params => {
          switch (params.event.target.id) {
            case 'moreDetail':
              this.modalService.showDetail(params.data, 'Asset Library Tab Detail')
              break;
            case 'editDetail':
              this.showItem(params?.data)
              break
            case 'delete':
              this.modalService.createNzDeleteModal(() => this.deleteRow.call(this, params?.data?.categoryId))
              break;
          }
        },
      }
    ];
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.getLibrary();
  }

  getLibrary() {
    this.assetService.getLibrary().subscribe((res: Array<any>) => {
      this.data = res
    })
  }

  showItem(orgData?) {
    const modal = this.nzModalService.create({
      nzContent: LibraryItemComponent,
      nzWidth: '80vw',
      nzBodyStyle: {
        'max-height': '70vh',
        'overflow-y': 'auto',
      },
      nzFooter: null,
      nzTitle: 'Set Library',
      nzComponentParams: {
        data: orgData,
      },
      nzOnOk: () => {
        const instance = modal.getContentComponent();
        const formData = instance.formGroup.value;

        if (!formData) {
          this.toastr.error('数据未提交');
          return false; // 阻止关闭
        }

        if (orgData) {
          this.editRow(formData);
        } else {
          this.addRow(formData);
        }

        this.toastr.info('Please check the preview results');
      }
    });
  }

  addRow(newData) {
    this.data = [...this.data, newData];
    this.gridApi.setRowData(this.data);
  }

  editRow(updatedData) {
    const index = this.data.findIndex(item => item.categoryId === updatedData.categoryId);
    if (index !== -1) {
      this.data[index] = updatedData;
      this.gridApi.setRowData(this.data);
    }
  }


  deleteRow(categoryId: string) {
    const index = this.data.findIndex(item => item.categoryId === categoryId);
    if (index !== -1) {
      this.data.splice(index, 1); // 从数组中移除
      this.gridApi.setRowData(this.data); // 刷新表格
      this.toastr.info('Please check the preview results');
    } else {
      this.toastr.error('can not find this row');
    }
  }


  preview() {
    const updatedData = this.getUpdatedRowData();
    const _data = this.libraryService.formatData(updatedData);
    this.assetService.previewLibrary(_data).subscribe(res => {
      this.modalService.showDetail(res, 'Preview Detail');
    });
  }

  updateLibrary() {
    const updatedData = this.getUpdatedRowData();
    const _data = this.libraryService.formatData(updatedData);
    this.assetService.updateLibrary(_data).subscribe({
      next: (res) => {
        this.getLibrary();
        this.toastr.success('Data Update Successfully...!', 'Success');
      },
    });
  }


  getUpdatedRowData(): any[] {
    const updatedData: any[] = [];
    this.gridApi.forEachNode((node) => {
      updatedData.push(node.data);
    });
    return updatedData;
  }


}
